<template>
  <ul
    :hidden="!expanded"
    class="dropdown-menu"
    role="menu"
  >
    <li
      :role="item.separator ? 'separator' : 'none'"
      v-for="(item, i) in menu"
      :key="i"
    >
      <button
        v-if="!item.separator"
        :class="[
          'dropdown-menu__item',
          item.isDangerous && 'dropdown-menu-item_dangerous',
        ]"
        role="menuitem"
        :tabindex="expanded ? 0 : -1"
        @click="item.action"
        :disabled="item.disabled"
      >
        <img
          v-if="item.icon"
          :src="item.icon"
          alt=""
        >
        <span>{{ item.name }}</span>
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    menu: {
      type: Array,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
